/**
 * Scroll to section helper function.
 * @param id 
 */
export function scrollToSection(id: string): void {
    const section = document.getElementById(id);
  
    if (section) {
      const topOffset = section.offsetTop - 60; // Adjust for a fixed header or similar
      window.scrollTo({
        top: topOffset,
        behavior: 'smooth', // Smooth scrolling
      });
    }
  }  